import React from "react"


import OwnerRequestControl from "../../components/LaborAccessRequest/OwnerRequestControl/OwnerRequestControl"


function OwnerRequestControlPage() {
  return <OwnerRequestControl />
}

export default OwnerRequestControlPage
